import type { ReactNode } from 'react'
import { Info } from 'lucide-react'

/** Плашка-подсказка настроек курса: значок «i» и поясняющий текст. */
export const InfoPanel = ({ children }: { children: ReactNode }) => (
  <div className="flex items-center gap-4 rounded-2xl bg-foreground/5 p-5">
    <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-brand/15 text-brand">
      <Info className="size-5" />
    </span>
    <div className="space-y-1 text-[15px] leading-relaxed text-muted-foreground">{children}</div>
  </div>
)
